import { api, setAccessToken, setWorkspaceId, loadFromStorage } from "$lib/api/client";

export interface BillingStatus {
  plan: string;
  is_active: boolean;
  days_left: number | null;
  trial_ends_at: string | null;
  plan_expires_at: string | null;
  display: string;
}

interface AuthState {
  user: any | null;
  workspaces: any[];
  loading: boolean;
  billing: BillingStatus | null;
}

function createAuth() {
  let state = $state<AuthState>({ user: null, workspaces: [], loading: true, billing: null });

  async function bootstrap() {
    loadFromStorage();
    try {
      const me = await api("/auth/me");
      state.user = me;
      state.workspaces = me.workspaces || [];
      if (state.workspaces.length && !localStorage.getItem("takite.ws")) {
        setWorkspaceId(state.workspaces[0].id);
      }
      // Billing status (sem workspace header — é do usuário, não do workspace)
      try {
        state.billing = await api<BillingStatus>("/billing/status");
      } catch {
        state.billing = null;
      }
    } catch {
      state.user = null;
      state.billing = null;
    } finally {
      state.loading = false;
    }
  }

  async function login(email: string, password: string) {
    const r = await api("/auth/login", {
      method: "POST",
      body: JSON.stringify({ email, password }),
    });
    setAccessToken(r.access_token);
    state.user = r.user;
    await bootstrap();
  }

  async function register(email: string, password: string, name: string, invite_code?: string) {
    const r = await api("/auth/register", {
      method: "POST",
      body: JSON.stringify({ email, password, name, invite_code }),
    });
    setAccessToken(r.access_token);
    state.user = r.user;
    await bootstrap();
  }

  async function logout() {
    try {
      await api("/auth/logout", { method: "POST" });
    } catch {}
    setAccessToken(null);
    setWorkspaceId(null);
    state.user = null;
    state.workspaces = [];
    state.billing = null;
  }

  function selectWorkspace(id: string) {
    setWorkspaceId(id);
  }

  return {
    get user() { return state.user; },
    get workspaces() { return state.workspaces; },
    get loading() { return state.loading; },
    get billing() { return state.billing; },
    bootstrap, login, register, logout, selectWorkspace,
  };
}

export const auth = createAuth();
